var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('div', {
    staticClass: "card-body"
  }, [_c('file-upload', {
    attrs: {
      "title": "Upload het Locus bestand het aantal bestelde presales per winkel",
      "url": "/api/rest/locations/batch-generate-store-presale-labels",
      "instructions": _vm.instructions,
      "formFields": _vm.formFields,
      "accept": ".xlsx,.xls"
    },
    on: {
      "success": _vm.onUploadSuccess,
      "error": _vm.onUploadError,
      "reset": _vm.onReset
    }
  }), _vm.uploadStatus === 'success' ? _c('b-alert', {
    staticClass: "mt-4",
    attrs: {
      "show": "",
      "variant": "success"
    }
  }, [_c('h4', {
    staticClass: "instructions-title"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "check-circle"
    }
  }), _vm._v(" Bestand " + _vm._s(this.file.name) + " is succesvol geüpload en verwerkt ")], 1), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.uploadMessage))])])]) : _vm._e(), _vm.uploadStatus === 'error' ? _c('b-alert', {
    staticClass: "mt-4",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_c('h4', {
    staticClass: "instructions-title"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "times-circle"
    }
  }), _vm._v(" Bestand " + _vm._s(this.file.name) + " is niet verwerkt ")], 1), _c('ul', _vm._l(_vm.errors, function (error, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(error.message))]);
  }), 0)]) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }